<template>
  <section
    class="block-home-fake-news decryptage-container"
    v-if="isLessThanDesktop"
  >
    <div class="fakeNewsSwiper">
      <swiper
        :effect="'coverflow'"
        :grabCursor="true"
        :navigation="true"
        :centeredSlides="true"
        :slidesPerView="1.66"
        :loop="true"
        :coverflowEffect="{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
        }"
        :pagination="{
          bulletElement: 'button',
        }"
        :modules="modules"
        class="swiper"
      >
        <swiper-slide
          v-for="(article, i) in content.getDecodingArticles()"
          :key="article.title"
          tag="a"
          :href="article.getLink()"
          :title="article.getTitle()"
        >
          <DecryptageCard :article="article" isMobileDisplay :cardIndex="i" trackLabel="fakenews_home_decoding_card"/>
        </swiper-slide>
      </swiper>
    </div>
    <div class="wrapper-btn text-align-center" v-if="isFakeNewsType()">
      <a
        :href="content.getDecodingLinkUri()"
        class="btn-small"
        :title="content.getDecodingLinkTitle()"
      >
        {{ content.getDecodingLinkTitle() }}
      </a>
    </div>
  </section>

  <section class="block-home-fake-news decryptage-container" v-else>
    <div class="tns-parent-decryptage">
      <div class="block-three-col tns-carrousel-decryptage">
        <DecryptageCard
          v-for="(article, i) in content.getDecodingArticles()"
          :key="article.title"
          :article="article"
          :cardBigImgWithoutBg="cardBigImgWithoutBg"
          @onClickCardCategory="onClickCardCategory(article)"
          @onClickCardSubCategory="onClickCardCategory(article, 'isSubCategory')"
          :cardIndex="i"
          trackLabel="fakenews_home_decoding_card"
        />
      </div>
    </div>
    <div class="wrapper-btn text-align-center" v-if="isFakeNewsType()">
      <a
        :href="content.getDecodingLinkUri()"
        class="btn-small"
        :title="content.getDecodingLinkTitle()"
      >
        {{ content.getDecodingLinkTitle() }}
      </a>
    </div>
  </section>
</template>
<script>
import { inject } from 'vue';
import { EffectCoverflow, Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import 'swiper/swiper-bundle.min.css';

import DecryptageCard from '@/components/sharedComponents/DecryptageCard.component.vue';
import { FakeNewsModel } from '@/models';
import DecryptageUtils from '@/utils/decryptage';

export default {
  components: {
    DecryptageCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    cardBigImgWithoutBg: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isLessThanDesktop = inject('isLessThanDesktop');
    const baseUrl = inject('decodingBaseUrl');

    function isFakeNewsType() {
      return props.content instanceof FakeNewsModel;
    }
    function onClickCardCategory(item, isSubCategory = '') {
      const article = isSubCategory !== 'isSubCategory'
        ? {
          id: item.categoryId,
          isEnabled: true,
          name: item.category,
        }
        : {
          id: item.subCategoryId,
          isEnabled: true,
          name: item.subCategory,
          mainCategory: item.category,
          mainCategoryId: item.categoryId,
          subCategory: true,
        };
      sessionStorage.setItem('currentFakeNewsCategory', JSON.stringify(article));

      const urlArr = [
        baseUrl.value,
      ];

      if (isSubCategory === 'isSubCategory') {
        urlArr.push(DecryptageUtils.encodeCategory(article?.mainCategory));
        urlArr.push(DecryptageUtils.encodeCategory(article?.name));
      } else {
        urlArr.push(DecryptageUtils.encodeCategory(article?.name));
      }

      window.location.href = `${urlArr.join('/')}`;
    }
    return {
      isLessThanDesktop,
      modules: [EffectCoverflow, Pagination, Navigation],
      isFakeNewsType,
      onClickCardCategory,
    };
  },
};
</script>
